import {
    IconMobileDeviceRegular,
    IconSmsRegular,
    IconInternetDeviceRegular,
    Spinner,
    Text2,
    Text3,
    Text6,
    Text8,
    EmptyState,
    NavigationBar,
    IconChevronLeftRegular,
    ThemeVariant,
    skinVars,
    Row,
    RowList,
    IconEuroSymbolCircleRegular,
} from '@telefonica/mistica';
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getAllConsDetail } from '../../../../services/ConsumptionService';
import './index.scss';
import { dateToLongMonth, getFormatDate, getStringCycle } from '../../../../utils/dataTransformation/dateConversions';
import {
    conversionKBtoMbOrGB,
    formatMobileNumber,
    formatPrices,
    formatTimeDetail,
} from '../../../../utils/dataTransformation/unitsConversion';
import InfiniteScroll from 'react-infinite-scroll-component';
import { t } from 'i18next';
import { getPhoneById, getRoleLine } from '../../../../utils/dataTransformation/productConsumption';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';
import Stopper from '../../../../components/Stopper';
import { managementEnvironment } from '../../../../utils/dataTransformation/environments';
import BreadCrumbsWrapper from '../../../../components/BreadcrumbsWrapper';
import { useConfigureLineContext } from '../../../../utils/store/context/configure-line-context/ConfigureLineContext';

const ExtraExpenseDetails: React.FC = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [isLoading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    const productPsId: any = searchParams.get('productPsId');
    const [page, setPage] = useState(1);
    const [moreElements, setMoreElements] = useState(true);
    const { trackingScreenView } = new TrackingEvents();
    const [windowWidth, setWindowWidth] = useState<any>(window.innerWidth);
    const homeDisabled = managementEnvironment().REACT_APP_STOPPER_HOME_DISABLED;
    const { isConvergent } = useConfigureLineContext();

    const storage = localStorage.getItem('storage');
    const consumptions = window.localStorage.getItem('storages')!;

    let number: any;
    let extraExpense = 0;
    let storageJson: any;
    let cicloInfo: string = '';
    let extraSum = 0;
    if (storage) {
        storageJson = JSON.parse(storage);
        if (storageJson) {
            number = storageJson.number;
            extraSum = storageJson.extraSum;
            if (storageJson.data) {
                extraExpense = storageJson.data?.extra;
            } else {
                extraExpense = 0;
            }
            cicloInfo = getStringCycle(storageJson.cycleStarts, storageJson.cycleEnds);
        }
    }

    const getRootPath = () => {
        return window.location.pathname.includes('phone') ? 'phone' : 'mobile';
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        getMoreDetails();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const getMoreDetails = () => {
        const params = {
            productPsId: productPsId,
            onlyExtras: true,
            page: page,
            size: 20,
        };
        getAllConsDetail(params).then((res: any) => {
            const data = res.data.details;
            setList(list.concat(data));
            setPage(page + 1);
            setMoreElements(res.data.moreElements);
            setLoading(false);
        });
    };

    if (isLoading) {
        return (
            <div className='extraExpenseDetails-page'>
                <div className='extraExpenseDetails-page__loading'>
                    <div className='extraExpenseDetails-page__loading__spinner'>
                        <Spinner size={'32px'} color={skinVars.colors.navigationBarBackground}></Spinner>
                    </div>
                </div>
            </div>
        );
    }

    return homeDisabled ? (
        <Stopper></Stopper>
    ) : (
        <div className='extraExpenseDetails-page'>
            <div
                style={{
                    zIndex: 99999,
                    background: skinVars.colors.backgroundBrand,
                    position: windowWidth >= 1024 ? 'static' : 'sticky',
                    top: 0,
                }}
            >
                {!(isWebviewAndroid || isWebviewIOS) && (
                    <>
                        <div className='extraExpenseDetails-page-navigationBar'>
                            <NavigationBar
                                isInverse={true}
                                onBack={() => {
                                    navigate(-1);
                                }}
                                title={t('returnExtraExpenseDetail')}
                            />
                        </div>
                        <div className='extraExpenseDetails-page-return'>
                            <div
                                className='extraExpenseDetails-page-return-cursor'
                                onClick={() => {
                                    navigate(-1);
                                }}
                            >
                                <div className='extraExpenseDetails-page-return-icon'>
                                    <IconChevronLeftRegular color={skinVars.colors.appBarBackground} size={20} />
                                </div>
                                <Text2 medium color={skinVars.colors.appBarBackground}>
                                    {t('returnResponsive')}
                                </Text2>
                            </div>
                        </div>
                    </>
                )}
                <div className='extraExpenseDetails-page-breadcrumbs'>
                    <ThemeVariant isInverse>
                        <BreadCrumbsWrapper
                            title={t('returnExtraExpenseDetail')}
                            breadcrumbs={
                                !isConvergent
                                    ? [{ title: t('breadcrumbsHome'), url: '/home' }]
                                    : [
                                          { title: t('breadcrumbsHome'), url: '/home' },
                                          {
                                              title:
                                                  getRootPath() === 'phone'
                                                      ? getPhoneById(
                                                            JSON.parse(consumptions!),
                                                            searchParams.get('productPsId')!,
                                                        )
                                                      : getRoleLine(
                                                            JSON.parse(consumptions),
                                                            searchParams.get('productPsId')!,
                                                        ),
                                              url: `/${getRootPath()}?productPsId=${searchParams.get('productPsId')!}`,
                                          },
                                      ]
                            }
                        />
                    </ThemeVariant>
                </div>
                <div className='extraExpenseDetails-page__number'>
                    <Text3 regular color={skinVars.colors.textNavigationBarPrimary}>
                        {formatMobileNumber(number)}
                    </Text3>
                </div>
                <div className='extraExpenseDetails-page__cycle'>
                    <Text6 color={skinVars.colors.textPrimaryInverse}>{cicloInfo}</Text6>
                </div>
                <div className='extraExpenseDetails-page__spent'>
                    <Text8 color={skinVars.colors.textPrimaryInverse}>{formatPrices(extraSum, 'spent')}</Text8>
                </div>
            </div>
            {(list || []).length <= 0 ? (
                <div className='extraExpenseDetails-page__emptyState'>
                    <EmptyState
                        icon={<IconEuroSymbolCircleRegular color={skinVars.colors.brand} size={64} />}
                        title={t('titleExtraExpense')}
                        description={t('descriptionExtraExpense')}
                    ></EmptyState>
                </div>
            ) : (
                <div className='extraExpenseDetails-page__content'>
                    <InfiniteScroll
                        dataLength={list.length}
                        next={getMoreDetails}
                        hasMore={moreElements}
                        loader={<h4>Loading...</h4>}
                    >
                        <RowList>
                            {(list || [])?.map((_item: any, index: number) => {
                                let pivot = ' ';
                                const longMonth = dateToLongMonth(_item?.dateTime.substring(5, 7));
                                if (index != 0) {
                                    const value: any = list[index - 1];
                                    pivot = value.dateTime.substring(8, 10);
                                }
                                if (index == 0) {
                                    return (
                                        <div key={index}>
                                            <div className='extraExpenseDetails-page__subtitle'>
                                                <Text3 medium color={skinVars.colors.textSecondary}>
                                                    {_item?.dateTime.substring(8, 10)} {longMonth}
                                                </Text3>
                                            </div>
                                            <Row
                                                title=''
                                                key={index}
                                                asset={
                                                    _item?.consumptionType == 'SMS' ? (
                                                        <IconSmsRegular />
                                                    ) : _item?.consumptionType == 'DATA' ? (
                                                        <IconInternetDeviceRegular />
                                                    ) : (
                                                        <IconMobileDeviceRegular />
                                                    )
                                                }
                                                right={
                                                    <div>
                                                        <Text6
                                                            color={
                                                                _item?.cost > 0
                                                                    ? skinVars.colors.errorHigh
                                                                    : skinVars.colors.textPrimary
                                                            }
                                                        >
                                                            {formatPrices(_item?.cost, 'spent')}
                                                        </Text6>
                                                    </div>
                                                }
                                                headline={
                                                    <div className='DetailConsumption__row-headline'>
                                                        <div className='DetailConsumption__row-headline-consumption'>
                                                            {_item?.consumptionType === 'VOICE' ||
                                                            _item?.consumptionType === 'SMS' ? (
                                                                <div>
                                                                    <Text3 regular>
                                                                        {formatMobileNumber(_item?.number)}
                                                                    </Text3>
                                                                </div>
                                                            ) : (
                                                                <div>
                                                                    <Text3 regular>
                                                                        {conversionKBtoMbOrGB(_item?.usage)}
                                                                    </Text3>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                }
                                                extra={
                                                    <div className='DetailConsumption__row-extra'>
                                                        {_item?.consumptionType === 'VOICE' ? (
                                                            <Text2 regular color={skinVars.colors.textSecondary}>
                                                                {`${getFormatDate(
                                                                    _item?.dateTime,
                                                                    '00:00',
                                                                )} - ${formatTimeDetail(_item?.usage)}`}
                                                            </Text2>
                                                        ) : (
                                                            _item?.consumptionType === 'SMS' && (
                                                                <Text2 regular color={skinVars.colors.textSecondary}>
                                                                    {`${getFormatDate(_item?.dateTime, '00:00')} - ${t(
                                                                        'sms',
                                                                    )}`}
                                                                </Text2>
                                                            )
                                                        )}
                                                    </div>
                                                }
                                            ></Row>
                                        </div>
                                    );
                                } else if (pivot != _item?.dateTime.substring(8, 10)) {
                                    return (
                                        <div key={index}>
                                            <div className='extraExpenseDetails-page__subtitle'>
                                                <Text3 medium color={skinVars.colors.textSecondary}>
                                                    {_item.dateTime.substring(8, 10)} {longMonth}
                                                </Text3>
                                            </div>
                                            <Row
                                                title=''
                                                key={index}
                                                asset={
                                                    _item.consumptionType == 'SMS' ? (
                                                        <IconSmsRegular />
                                                    ) : _item.consumptionType == 'DATA' ? (
                                                        <IconInternetDeviceRegular />
                                                    ) : (
                                                        <IconMobileDeviceRegular />
                                                    )
                                                }
                                                right={
                                                    <div>
                                                        <Text6
                                                            color={
                                                                _item.cost > 0
                                                                    ? skinVars.colors.errorHigh
                                                                    : skinVars.colors.textPrimary
                                                            }
                                                        >
                                                            {formatPrices(_item.cost, 'spent')}
                                                        </Text6>
                                                    </div>
                                                }
                                                headline={
                                                    <div className='DetailConsumption__row-headline'>
                                                        <div className='DetailConsumption__row-headline-consumption'>
                                                            {_item?.consumptionType === 'VOICE' ||
                                                            _item?.consumptionType === 'SMS' ? (
                                                                <div>
                                                                    <Text3 regular>
                                                                        {formatMobileNumber(_item?.number)}
                                                                    </Text3>
                                                                </div>
                                                            ) : (
                                                                <div>
                                                                    <Text3 regular>
                                                                        {conversionKBtoMbOrGB(_item?.usage)}
                                                                    </Text3>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                }
                                                extra={
                                                    <div className='DetailConsumption__row-extra'>
                                                        {_item.consumptionType === 'VOICE' ? (
                                                            <Text2 regular color={skinVars.colors.textSecondary}>
                                                                {`${getFormatDate(
                                                                    _item.dateTime,
                                                                    '00:00',
                                                                )} - ${formatTimeDetail(_item.usage)}`}
                                                            </Text2>
                                                        ) : (
                                                            _item?.consumptionType === 'SMS' && (
                                                                <Text2 regular color={skinVars.colors.textSecondary}>
                                                                    {`${getFormatDate(_item?.dateTime, '00:00')} - ${t(
                                                                        'sms',
                                                                    )}`}
                                                                </Text2>
                                                            )
                                                        )}
                                                    </div>
                                                }
                                            ></Row>
                                        </div>
                                    );
                                } else {
                                    return (
                                        <div key={index}>
                                            <Row
                                                title=''
                                                key={index}
                                                asset={
                                                    _item?.consumptionType == 'SMS' ? (
                                                        <IconSmsRegular />
                                                    ) : _item?.consumptionType == 'DATA' ? (
                                                        <IconInternetDeviceRegular />
                                                    ) : (
                                                        <IconMobileDeviceRegular />
                                                    )
                                                }
                                                right={
                                                    <div>
                                                        <Text6
                                                            color={
                                                                _item?.cost > 0
                                                                    ? skinVars.colors.errorHigh
                                                                    : skinVars.colors.textPrimary
                                                            }
                                                        >
                                                            {formatPrices(_item?.cost, 'spent')}
                                                        </Text6>
                                                    </div>
                                                }
                                                headline={
                                                    <div className='DetailConsumption__row-headline'>
                                                        <div className='DetailConsumption__row-headline-consumption'>
                                                            {_item?.consumptionType === 'VOICE' ||
                                                            _item?.consumptionType === 'SMS' ? (
                                                                <div>
                                                                    <Text3 regular>
                                                                        {formatMobileNumber(_item?.number)}
                                                                    </Text3>
                                                                </div>
                                                            ) : (
                                                                <div>
                                                                    <Text3 regular>
                                                                        {conversionKBtoMbOrGB(_item?.usage)}
                                                                    </Text3>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                }
                                                extra={
                                                    <div className='DetailConsumption__row-extra'>
                                                        {_item?.consumptionType == 'VOICE' ? (
                                                            <Text2 regular color={skinVars.colors.textSecondary}>
                                                                {`${getFormatDate(
                                                                    _item?.dateTime,
                                                                    '00:00',
                                                                )} - ${formatTimeDetail(_item?.usage)}`}
                                                            </Text2>
                                                        ) : (
                                                            _item?.consumptionType === 'SMS' && (
                                                                <Text2 regular color={skinVars.colors.textSecondary}>
                                                                    {`${getFormatDate(_item?.dateTime, '00:00')} - ${t(
                                                                        'sms',
                                                                    )}`}
                                                                </Text2>
                                                            )
                                                        )}
                                                    </div>
                                                }
                                            ></Row>
                                        </div>
                                    );
                                }
                            })}
                        </RowList>
                    </InfiniteScroll>
                </div>
            )}
        </div>
    );
};

export default ExtraExpenseDetails;
